import { makeStyles } from "@material-ui/styles";
// import loginBG from "../../images/loginBG.jpg";

export default makeStyles((theme) => ({
  mainContainer: { width: "100%", height: "100%" },
  signMap: { width: "100%", height: "100%" },
}));
